const pageDateTime = Object.freeze({
  fontFamily: 'base',
  separator: 'unset',
  timeFormat: 'HH:mm',
  dateFormat: 'dd בMMMM, yyyy',
});

export default pageDateTime;
